(() => {
  'use strict';
  if (!customElements.get('csb-engraving-trial')) {
    class CsbEngravingTrial extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound=true;this.generation=(this.generation||0)+1;const generation=this.generation;
        this.scene=this.querySelector('csb-steel-product-scene');this.form=this.querySelector('form');
        this.row=this.querySelector('[data-row]');this.limitLabel=this.querySelector('[data-limit]');this.row.value='last';
        this.input=this.querySelector('input');this.submit=this.querySelector('[type="submit"]');
        this.resetButton=this.querySelector('[data-reset]');this.status=this.querySelector('.steel-trial-status');
        this.error=this.querySelector('.steel-word-error');this.count=this.querySelector('[data-count]');
        this.result=this.querySelector('.steel-word-result');this.resultWord=this.querySelector('[data-result]');
        this.listeners=[];this.elapsed=0;this.frame=0;this.running=false;this.inView=true;
        this.preference=window.matchMedia('(prefers-reduced-motion: reduce)');
        const bind=(el,type,fn)=>{el.addEventListener(type,fn);this.listeners.push([el,type,fn])};
        bind(this.form,'submit',event=>{event.preventDefault();this.start()});
        bind(this.input,'input',()=>{this.count.textContent=`${this.input.value.length} / ${this.limit()}`;this.error.textContent='';this.input.removeAttribute('aria-invalid')});
        bind(this.resetButton,'click',()=>this.reset());
        bind(this.row,'change',()=>this.changeRow());
        bind(this.scene,'csb:product-ready',()=>this.ready());
        bind(this.scene,'csb:product-fallback',()=>{this.stop();this.submit.disabled=true;this.status.textContent=this.dataset.unavailableLabel});
        bind(document,'visibilitychange',()=>this.sync());
        bind(this.preference,'change',()=>{if(this.running&&this.preference.matches)this.finish()});
        this.observer=new IntersectionObserver(entries=>{this.inView=entries.some(e=>e.isIntersecting);this.sync()});this.observer.observe(this);
        this.form.noValidate=true;
        customElements.whenDefined('csb-steel-product-scene').then(()=>{
          if(!this.isConnected||this.generation!==generation)return;
          this.scene.setWord('STEEL',this.row.value);
          if(this.scene.dataset.ready==='true')this.ready();
        });
      }
      ready() {
        this.stop();this.scene.setWord('STEEL',this.row.value);this.scene.showEngravings();this.form.hidden=false;this.submit.disabled=false;
        this.querySelector('.steel-trial-actions').hidden=false;
        this.status.textContent=this.dataset.readyLabel;
        this.dataset.ready='true';
      }
      limit() {return this.row.value==='last'?14:7}
      changeRow() {
        this.stop();this.scene.showEngravings();
        this.input.value=this.scene.completedRows?.[this.row.value]?.text||'';
        this.input.maxLength=this.limit();this.input.pattern=`[A-Za-z ]{1,${this.limit()}}`;
        this.limitLabel.textContent=this.row.value==='last'?this.dataset.limitLast:this.dataset.limitRow;
        this.count.textContent=`${this.input.value.length} / ${this.limit()}`;this.showResult();
        this.error.textContent='';this.input.removeAttribute('aria-invalid');
        if(this.input.value.length>this.limit()){this.error.textContent=this.dataset.errorRow;this.input.setAttribute('aria-invalid','true');}
        this.status.textContent=this.dataset.readyLabel;
      }
      start() {
        if(this.scene.dataset.ready!=='true')return;
        const word=this.input.value.trim().toUpperCase();
        if(!/^[A-Z ]+$/.test(word)||word.length>this.limit()){
          this.error.textContent=this.row.value==='last'?this.dataset.errorLast:this.dataset.errorRow;this.input.setAttribute('aria-invalid','true');this.input.focus();return;
        }
        if(this.scene.isBlockedWord?.(word)){this.error.textContent=this.dataset.blockedLabel;this.input.setAttribute('aria-invalid','true');this.input.focus();return;}
        if(!this.scene.setWord(word,this.row.value)){this.error.textContent=this.dataset.fitLabel;this.input.setAttribute('aria-invalid','true');this.input.focus();return;}
        this.stop();this.word=word;this.input.value=word;this.count.textContent=`${word.length} / ${this.limit()}`;
        this.error.textContent='';this.input.removeAttribute('aria-invalid');this.result.hidden=true;
        this.elapsed=0;this.duration=2600+word.replace(/ /g,'').length*2700;
        this.running=true;this.submit.disabled=true;this.input.readOnly=true;
        this.status.textContent=this.dataset.workingLabel;this.form.setAttribute('aria-busy','true');
        if(this.preference.matches||this.manualPaused){this.finish();return;}this.sync();
      }
      sync() {
        if(!this.running||document.hidden||!this.inView){cancelAnimationFrame(this.frame);this.frame=0;this.last=null;return;}
        if(this.frame)return;
        const tick=time=>{
          this.frame=0;
          if(!this.running||document.hidden||!this.inView){this.last=null;return;}
          if(this.last!==null&&this.last!==undefined)this.elapsed+=Math.min(100,Math.max(0,time-this.last));
          this.last=time;const q=Math.min(1,this.elapsed/this.duration);
          this.scene.setProgress(.5+q/8);
          if(q>=1)this.finish();else this.frame=requestAnimationFrame(tick);
        };this.last=null;this.frame=requestAnimationFrame(tick);
      }
      finish() {
        this.stop();this.scene.commitWord();this.showResult();
        this.status.textContent=this.dataset.doneLabel;
      }
      showResult() {
        const rows=this.scene.completedRows||{};
        this.resultWord.textContent=['1','2','last'].map(row=>rows[row]?.text).filter(Boolean).join(' · ');
        this.result.hidden=!this.resultWord.textContent;
      }
      stop() {
        cancelAnimationFrame(this.frame);this.frame=0;this.running=false;this.last=null;
        this.submit.disabled=this.scene.dataset.ready!=='true';this.input.readOnly=false;this.form.removeAttribute('aria-busy');
      }
      reset() {
        this.stop();this.scene.clearEngravings();this.input.value='';this.count.textContent=`0 / ${this.limit()}`;
        this.error.textContent='';this.input.removeAttribute('aria-invalid');this.result.hidden=true;
        this.resultWord.textContent='';this.status.textContent=this.dataset.readyLabel;this.input.focus();
      }
      setPaused(value) {this.manualPaused=Boolean(value);if(this.running&&value)this.finish()}
      disconnectedCallback() {
        this.generation++;this.stop();this.observer?.disconnect();
        this.listeners?.forEach(([el,type,fn])=>el.removeEventListener(type,fn));this.listeners=[];this.bound=false;
      }
    }
    customElements.define('csb-engraving-trial',CsbEngravingTrial);
  }
})();
